export class vendorLogin {
    constructor(
        public vendorUserName?:string,
        public vendorPassword?:string
    ){
      this.vendorUserName = vendorUserName; 
      this.vendorPassword = vendorPassword;

    }
}